export const LOAD_REQUEST_FAILURE = 'LOAD_REQUEST_FAILURE';
